<template>
  <div>
    <el-table
      :data='tableData'
      :highlight-current-row='true'
      stripe
      row-class-name='pointer'
      v-bind='$attrs' v-on='$listeners'
      @sort-change='handleChangeSort'
      border>
      <el-table-column label='项目部/组' prop='dept_name' align='center' width='100' v-if='showDept'></el-table-column>
      <el-table-column label='平台ID' prop='account_id' align='center' width='100' />
      <el-table-column label='UID' prop='uid' align='center' width='100' />
      <template v-for='(col,index) in columns'>
        <el-table-column :prop='`${col.property||col.prop}`' :key='index' :label='`${col.label}`'
                         :min-width='`${col.width}`'
                         align='center' header-align='center'
                         :sortable='col.sortable?col.sortable:false'
                         show-overflow-tooltip>
          <template slot-scope='{row}'>
            <span @click='handleCopy(row[col.prop])'>{{ row[col.prop] }}</span>
          </template>
        </el-table-column>
      </template>
      <el-table-column label='更新时间' prop='updated_at' align='center' width='150'></el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: 'TablePanel',
  props: {
    tableData: {
      type: Array
    },
    columns: {
      type: Array
    },
    showDept: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    selectRow() {
      this.$emit('selectRow')
    },
    handleCopy(val) {
      //复制到剪切板
      navigator.clipboard.writeText(val)
        .then(() => {
          this.msgSuccess('复制成功')
        }).catch(err => console.error('复制失败:', err))
    },
    handleChangeSort({ prop, order }) {
      const orderSort = {}
      if (order) {
        orderSort[prop] = order === 'descending' ? 'desc' : 'asc'
      }
      this.$emit('handleChangeSort', orderSort)
    }
  }
}
</script>

<style scoped>

</style>
